module.exports = __webpack_public_path__ + "img/presteconta.b4848b84.png";